import React, { useState, useEffect } from 'react';
import WhatsAppButton from './whatsapp';
import './wardrobe_calculator.css';
import Header from './Header';
import Footer from './Footer';
import axios from 'axios';
import { uploadUrl } from './uploadUrl';
import Chat from './chat';
import { Helmet } from 'react-helmet';
import Call from './call';
import Marquee from './marquee';


const Calculatorkitchen = () => {
  const [step, setStep] = useState(1);

  const [categories, setcategories] = useState([]);
  const [subcategories, setsubcategories] = useState([]);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    categoryId: '',
    subcategoryId: '',
  });

 

  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(
          'https://api.squareandangle.pranatigroup.in/api/admin/category'
        );

        if (res.data) {
          setcategories(res.data);
        } else {
          setcategories([]);
        }
      } catch (err) {
        console.log(err);
      }
    };

    load();
  }, []);

  const nextStep = () => {
    if (step < 3) {
      setStep(step + 1);
    }
  };

  const prevStep = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  const handleclick = async () => {
    try {
      await axios.post(
        'https://api.squareandangle.pranatigroup.in/api/admin/payloadsub',
        {
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          categoryId: formData.categoryId,
          subcategoryId: formData.subcategoryId,
        }
      );


      alert('Submission successful');

      setFormData({
        name: '',
        email: '',
        phone: '',
        categoryId: '',
        subcategoryId: '',
      });

    
      setsubcategories([]);

      setStep(1);
    } catch (e) {
      console.error('Submission failed:', e);
      alert('Submission failed. Please try again.');
    }
  };

  const handlecategory = async (catId) => {
    const newform = {};

    for (let k in formData) {
      newform[k] = formData[k];
    }

    newform.categoryId = catId;
    newform.subcategoryId = '';

    setFormData(newform);

    

    try {
      const res = await axios.get(
        `https://api.squareandangle.pranatigroup.in/api/admin/subid/${catId}`
      );

      if (res.data && res.data.rows) {
        setsubcategories(res.data.rows);
      } else {
        setsubcategories([]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handlesubcategory = (subcatId) => {
    const newform = {};

    for (let k in formData) {
      newform[k] = formData[k];
    }

    newform.subcategoryId = subcatId;

    setFormData(newform);

    
  };

  const categoryelements = [];

  for (let i = 0; i < categories.length; i++) {
    categoryelements.push(
      <label
        key={categories[i].id}
        className={
          formData.categoryId === categories[i].id
            ? 'card selected'
            : 'card'
        }
      >
        <input
          type='radio'
          checked={formData.categoryId === categories[i].id}
          onChange={() => handlecategory(categories[i].id)}
        />

        <h4>{categories[i].category}</h4>
      </label>
    );
  }

  const subcategoryelements = [];

  for (let i = 0; i < subcategories.length; i++) {
    subcategoryelements.push(
      <label
        key={subcategories[i].id}
        className={
          formData.subcategoryId === subcategories[i].id
            ? 'card selected'
            : 'card'
        }
      >
        <input
          type='radio'
          checked={formData.subcategoryId === subcategories[i].id}
          onChange={() =>
            handlesubcategory(subcategories[i].id)
          }
        />

        {subcategories[i].images && (
          <div className='card-image'>
            <img
              src={uploadUrl(subcategories[i].images)}
              alt={subcategories[i].subcategory}
            />
          </div>
        )}

        <h4>{subcategories[i].subcategory}</h4>
      </label>
    );
  }

  const catin = [
    'Choose Any category',
    'Select one',
    'Put your details',
  ];

  return (
    <>
      <div className='app'>
        <Header />
        <Marquee/>
          <Helmet>
                 <title>Pranati Interior - Kolkata best Interior</title>
                 <meta name="description" content="Welcome to Kolkata best interior" />
         
                 <link rel="canonical" href="https://squareandangle.pranatigroup.in/wardrobe_calculator" />
         
                 <meta property="og:title" content="Pranati interior" />
                 <meta property="og:description" content="Kolkata best Interior" />
                 <meta property="og:image" content="/images/preview.png" />
                 <meta property="og:url" content="https://squareandangle.pranatigroup.in/wardrobe_calculator" />
         
                 <meta name="twitter:card" content="summary_large_image" />
                 <meta name="twitter:title" content="Pranati interior" />
                 <meta name="twitter:description" content="Kolkata best Interior" />
                 <meta name="twitter:image" content="/images/preview.png" />
         
                 <script type="application/ld+json">
                   {JSON.stringify({
                     "@context": "https://schema.org",
                     "@type": "LocalBusiness",
                     "name": "Pranati Interior",
                     "url": "https://squareandangle.pranatigroup.in/wardrobe_calculator",
                     "description": "Kolkata best Interior",
                     "image": "https://squareandangle.pranatigroup.in/images/preview.png",
                     "areaServed": "Kolkata",
                     "address": {
                       "@type": "PostalAddress",
                       "addressLocality": "Kolkata",
                       "addressRegion": "West Bengal",
                       "addressCountry": "IN"
                     }
                   })}
                 </script>
               </Helmet>
        <div className='calculator-box'>
          <div className="progressbar">
             {catin.map((cat, index) => (
          <div className='step' key={index}>
          <div className={`circle ${step > index + 1 ? 'active' : ''}`}>{step > index + 1 ? '✓' : ''}</div>
          <p className={step >= index + 1 ? 'active-label' : ''}>{cat}</p>
        </div>
        ))}
             </div>

          

          {step === 1 && (
            <>
              <h3>Select Category</h3>

              <div className='card-container'>
                {categoryelements}
              </div>

              <div className='nav-area'>
                <button className='nav-btn' disabled>
                  Back
                </button>

                <button
                  className='nav-btn'
                  disabled={!formData.categoryId}
                  onClick={nextStep}
                >
                  Next
                </button>
              </div>
            </>
          )}

          {step === 2 && (
            <>
              <h3>Select Subcategory</h3>

              <div className='card-container'>
                {subcategoryelements}
              </div>

              <div className='nav-area'>
                <button
                  className='nav-btn'
                  onClick={prevStep}
                >
                  Back
                </button>

                <button
                  className='nav-btn'
                  disabled={!formData.subcategoryId}
                  onClick={nextStep}
                >
                  Next
                </button>
              </div>
            </>
          )}

          {step === 3 && (
            <>
              <h3>Enter Details</h3>

              <div className='form-container'>
                

                <input
                  type='text'
                  placeholder='Name'
                  value={formData.name}
                  onChange={(e) => {
                    const newformdata = {};

                    for (let k in formData) {
                      newformdata[k] = formData[k];
                    }

                    newformdata.name = e.target.value;

                    setFormData(newformdata);
                  }}
                />

                <br />

                <input
                  type='email'
                  placeholder='Email'
                  value={formData.email}
                  onChange={(e) => {
                    const newformdata = {};

                    for (let k in formData) {
                      newformdata[k] = formData[k];
                    }

                    newformdata.email = e.target.value;

                    setFormData(newformdata);
                  }}
                />

                <br />

                <div className='phone-input'>
                  <span className='flag'>+91</span>

                  <input
                    type='number'
                    placeholder='Phone'
                    value={formData.phone}
                    onChange={(e) => {
                      const newformData = {};

                      for (let k in formData) {
                        newformData[k] = formData[k];
                      }

                      newformData.phone = e.target.value;

                      setFormData(newformData);
                    }}
                  />
                </div>

                <div className='nav-area'>
                  <button
                    className='nav-btn'
                    onClick={prevStep}
                  >
                    Back
                  </button>

                  <button
                    className='nav-btn'
                    onClick={handleclick}
                 disabled={
                      !formData.name ||
                      !formData.email ||
                      !formData.phone 
                    }
                  >
                    Submit
                  </button>
                </div>

                <p className='terms'>
                  By submitting this form, you agree
                  to the
                  <span> privacy policy </span>
                  &
                  <span> terms and conditions</span>

                  <br />

                  This site is protected by reCAPTCHA
                  and the Google
                  <span> Privacy Policy </span>
                  and
                  <span> Terms of Service </span>
                  apply.
                </p>
              </div>
            </>
          )}
        </div>

        

        <Footer />
          <WhatsAppButton />
      <Chat/>
       <Call/>
      </div>
    </>
  );
};

export default Calculatorkitchen;